import { cx } from '../lib/cx';

/** Initials never go below the 11.5px floor of the type scale. */
const FONT: Record<number, number> = { 18: 11.5, 22: 11.5, 24: 11.5, 28: 11.5, 30: 12.5, 32: 12.5, 36: 13.5, 40: 15 };

/** Initials in a coloured circle. Guides keep their own fixed colour from the API. */
export function Avatar({
  initials,
  color,
  size = 40,
  label,
  className,
}: {
  initials: string;
  color: string;
  size?: number;
  label?: string;
  className?: string;
}) {
  return (
    <span
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      className={cx('inline-flex shrink-0 items-center justify-center rounded-full font-bold text-deep', className)}
      style={{ width: size, height: size, background: color, fontSize: FONT[size] ?? Math.max(11.5, Math.round(size / 2.8)) }}
    >
      {initials}
    </span>
  );
}

/** Seth's own mark: a serif "S" on sand or deep blue. */
export function SethAvatar({ size = 40, tone = 'sand' }: { size?: number; tone?: 'sand' | 'deep' }) {
  return (
    <span
      aria-hidden="true"
      className={cx(
        'inline-flex shrink-0 items-center justify-center rounded-full font-display font-bold',
        tone === 'sand' ? 'bg-sand text-deep' : 'bg-deep text-sand',
      )}
      style={{ width: size, height: size, fontSize: Math.max(11.5, Math.round(size * 0.46)) }}
    >
      S
    </span>
  );
}
